/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import { ReactScriptLoaderMixin } from "react-script-loader";

const PlaidLink = createReactClass({
  mixins: [ReactScriptLoaderMixin],
  getDefaultProps: function () {
    return {
      selectAccount: false,
      buttonText: "Open Link"
    };
  },
  propTypes: {
    linkToken: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onExit: PropTypes.func,
    onLoad: PropTypes.func,
    selectAccount: PropTypes.bool,
    buttonText: PropTypes.string,
    className: PropTypes.string
  },
  getInitialState: function () {
    return {
      disabledButton: true,
      linkLoaded: false
    };
  },
  getScriptURL: function () {
    return "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
  },
  onScriptError: function () {
    console.error("There was an issue loading the link-initialize.js script");
  },
  onScriptLoaded: function () {
    window.linkHandler = window.Plaid.create({
      token: this.props.linkToken,
      onExit: this.props.onExit,
      onLoad: this.handleLinkOnLoad,
      onSuccess: this.props.onSuccess,
      selectAccount: this.props.selectAccount
    });
    this.setState({ disabledButton: false });
  },
  handleLinkOnLoad: function () {
    if (this.props.onLoad) {
      this.props.onLoad();
    }
    this.setState({ linkLoaded: true });
  },
  handleOnClick: function () {
    if (window.linkHandler) {
      window.linkHandler.open();
    }
  },
  exit: function (configurationObject) {
    if (window.linkHandler) {
      window.linkHandler.exit(configurationObject);
    }
  },
  render: function () {
    return (
      <a
        onClick={this.handleOnClick}
        disabled={this.state.disabledButton}
        className={this.props.className}
      >
        {this.props.children || this.props.buttonText}
      </a>
    );
  }
});

export default PlaidLink;
